import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable({providedIn: 'root'})
export class AuthGuardService  {

  constructor(private _router: Router, private _authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this._authService.isLoggedIn().then(t => {
      this._authService.redirectUrl = state.url;
      if (!t) {
        const loginPath = this._router.parseUrl('/login');
        return new RedirectCommand(loginPath, {skipLocationChange: false});
      }

      // make sure user has permissions to the route
      const user = this._authService.getUser();

      if (user.isUserAdmin) { return true; }

      if (state.url === '/user-accounts') {
        const homePath = this._router.parseUrl('/home');
        return new RedirectCommand(homePath);
      }
      // ...

      return t;
    });
  }
}
